<template>
  <hr class="h-separator" />
</template>

<style lang="scss" scoped>
.h-separator {
  border: none;
  height: 1px;
  width: 100%;
  background-color: var(--ullib-color-accent-2);
  margin: 0;
  flex-shrink: 0;
}
</style>
